<template>
  <section class="content-section contpadd">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="section-title text-center xsmar2">
            <!-- 		  <h6>CONNECT WITH US</h6> -->
            <h2>Get in Touch</h2>
          </div>
          <!-- end section-title -->
        </div>
        <!-- end col-12 -->
        <div class="col-lg-4">
          <div class="contact-box">
            <figure>
              <img src="images/location.png" alt="Image" />
            </figure>
            <h5>VISIT US</h5>
            <p>HiLITE City, Palazhi, NH-66, Thondayad By-pass, Calicut</p>
          </div>
          <!-- end contact-box -->
        </div>
        <!-- end col-4 -->
        <div class="col-lg-4">
          <div class="contact-box">
            <figure>
              <img src="images/phone.png" alt="Image" />
            </figure>
            <h5>CALL US</h5>
            <p>
              +91 7994441444 <br />
           
            </p>
          </div>
          <!-- end contact-box -->
        </div>
        <!-- end col-4 -->
        <div class="col-lg-4">
          <div class="contact-box">
            <figure>
              <img src="images/mail.png" alt="Image" />
            </figure>
            <h5>WRITE TO US</h5>
            <p>
              <a href="#">tech@palaxi.com</a><br />
            </p>
          </div>
          <!-- end contact-box -->
        </div>
        <!-- end col-4 -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </section>
  <!-- end content-section -->
</template>
<script>
export default {
    
}
</script>